module.exports = __webpack_public_path__ + "@/assets/img/building.93bbd502.svg";